export const COLLEGE_LINKS = {
  BC: 'https://www.bcpharmacists.org/',
  ON: 'https://www.ocpinfo.com/',
  ROC: '',
  AB: 'https://abpharmacy.ca.mcas.ms/wp-content/uploads/Poster_PatientConcerns.pdf?McasCtx=4&McasTsid=20893',
};

export const ACCREDITED_BY_LOGO_ON =
  'https://dis-prod.assetful.loblaw.ca/content/dam/loblaw-companies-limited/creative-assets/shoppers-drug-mart/sdm-phx/digital/web/projects/2023/p11/on-ocp-logo/OCP-2021-logo-140x140-2x.png';

export const PROFILE_PICTURE =
  'https://dis-prod.assetful.loblaw.ca/content/dam/loblaw-companies-limited/creative-assets/shoppers-drug-mart/sdm-phx/digital/web/store-profile/photos/';

export const PHARMACY_LICENSE =
  'https://dis-prod.assetful.loblaw.ca/content/dam/loblaw-companies-limited/creative-assets/shoppers-drug-mart/sdm-phx/digital/web/store-profile/licenses/';
